import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import Utils from "../utils/Utils";

export default defineComponent({
    template: `
        <div class="vhome">
            <div v-if="html" v-html="html.body"></div>
        </div>
    `,

    setup(props, ctx) {
        const html = ref(null);

        async function reload() {
            html.value = (await Utils.get('/api/pages/maintenance')).html;
        }

        onMounted(() => {
            reload();

            $('body').addClass('body--vhome body--vmaintenance');
        });

        onUnmounted(() => {
            $('body').removeClass('body--vhome body--vmaintenance');
        });

        return {
            html,
        };
    },
});
